import { TFetchConverter } from 'data/types/converter.types';
import {
  TDuplicatePairDB,
  TDuplicatePairUI,
  TMatchCriteria,
  TMergeHistoryEntryDB,
  TMergeHistoryEntryUI,
  TMergeRecordsResponseDB,
  TMergeRecordsResponseUI,
  TSearchDuplicatesResponseDB,
  TSearchDuplicatesResponseUI,
  TSearchMergeHistoryResponseDB,
  TSearchMergeHistoryResponseUI,
} from 'data/types/duplicateManagement.types';

const parseJsonOrNull = <T>(raw: string | null | undefined): T | null => {
  if (!raw) return null;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
};

export const duplicatePairConverter: TFetchConverter<
  TDuplicatePairUI,
  TDuplicatePairDB
> = {
  fromDb: data => ({
    ...data,
    matchCriteria: parseJsonOrNull<TMatchCriteria>(data.matchCriteria),
  }),
};

export const searchDuplicatesResponseConverter: TFetchConverter<
  TSearchDuplicatesResponseUI,
  TSearchDuplicatesResponseDB
> = {
  fromDb: data => ({
    ...data,
    duplicates: (data.duplicates || []).map(duplicatePairConverter.fromDb),
  }),
};

export const mergeRecordsResponseConverter: TFetchConverter<
  TMergeRecordsResponseUI,
  TMergeRecordsResponseDB
> = {
  fromDb: data => ({
    ...data,
    fieldDeltas: parseJsonOrNull<Record<string, unknown>>(data.fieldDeltas),
    relatedEntitiesUpdated: parseJsonOrNull<Record<string, unknown>>(
      data.relatedEntitiesUpdated,
    ),
  }),
};

export const mergeHistoryEntryConverter: TFetchConverter<
  TMergeHistoryEntryUI,
  TMergeHistoryEntryDB
> = {
  fromDb: data => ({
    ...data,
    mergedRecordIds: parseJsonOrNull<string[]>(data.mergedRecordIds) ?? [],
    fieldDeltas: parseJsonOrNull<Record<string, unknown>>(data.fieldDeltas),
    relatedEntitiesUpdated: parseJsonOrNull<Record<string, unknown>>(
      data.relatedEntitiesUpdated,
    ),
  }),
};

export const searchMergeHistoryResponseConverter: TFetchConverter<
  TSearchMergeHistoryResponseUI,
  TSearchMergeHistoryResponseDB
> = {
  fromDb: data => ({
    ...data,
    mergeHistory: (data.mergeHistory || []).map(
      mergeHistoryEntryConverter.fromDb,
    ),
  }),
};
